var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "tile": "",
      "max-width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--lg"
  }, [_c('span', {
    staticClass: "py-4 pl-4"
  }, [_c('b', [_vm._v("모바일 도서교환권")])])]), _c('v-divider'), _c('v-card-text', [_c('p', {
    staticClass: "mb-0 pl-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "size": "20",
      "color": "orange darken-2"
    }
  }, [_vm._v("mdi-help-circle-outline")]), _c('b', [_vm._v("모바일 도서교환권 이용방법")]), _vm._v("!")], 1), _c('v-img', {
    attrs: {
      "src": "/images/sub/exchange-guide.jpg",
      "width": "100%",
      "contain": ""
    }
  })], 1), _c('v-divider'), _c('v-card-text', [_c('v-radio-group', {
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, [_c('v-row', _vm._l(_vm.products, function (product) {
    return _c('v-col', {
      key: product._id,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('v-card', {
      attrs: {
        "elevation": "0"
      }
    }, [_c('v-card-text', {
      staticClass: "black--text"
    }, [_c('v-img', {
      staticClass: "mx-auto",
      attrs: {
        "src": product.thumb,
        "max-width": "500",
        "height": "172",
        "contain": ""
      }
    }), _c('v-responsive', {
      staticClass: "mt-4 text-center"
    }, [_c('div', {
      staticClass: "tit tit--xs text-truncate"
    }, [_vm._v(_vm._s(product.name))]), _c('v-layout', {
      staticClass: "mt-1 caption text-truncate",
      attrs: {
        "justify-center": ""
      }
    }, [_c('span', [_vm._v(_vm._s(product.writer))]), product.writer && product.publisher ? _c('v-divider', {
      staticClass: "mx-2 my-1",
      attrs: {
        "vertical": ""
      }
    }) : _vm._e(), _c('span', [_vm._v(_vm._s(product.publisher))])], 1), _c('div', {
      staticClass: "font-size-16 mt-1"
    }, [_c('b', {
      staticClass: "primary--text"
    }, [_vm._v(_vm._s(product.salePrice.format()))]), _vm._v(" 원")]), _c('div', {
      staticClass: "text-center my-2"
    }, [_c('v-radio', {
      staticClass: "d-inline-block",
      attrs: {
        "value": product._id
      }
    })], 1)], 1)], 1)], 1)], 1);
  }), 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-btn', {
    staticClass: "mx-auto",
    attrs: {
      "width": "140",
      "color": "accent",
      "x-large": ""
    },
    on: {
      "click": _vm.order
    }
  }, [_vm._v("선물교환")])], 1)], 1), _c('login-dialog', {
    ref: "loginDialog"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }